import {
  FETCH_ACCESS_REQUESTS,
  STORE_INCOMING_ACCESS_REQUESTS,
  STORE_OUTGOING_ACCESS_REQUESTS,
  FETCH_PENDING_ACCESS_FOR_USERS,
  STORE_PENDING_ACCESS_FOR_USERS,
  DECIDE_ACCESS_REQUEST,
} from '../../constants/accessRequests';

export const fetchAccessRequests = (data) => ({
  type: FETCH_ACCESS_REQUESTS,
  data,
});

export const storeIncomingAccessRequests = (pending, decided) => ({
  type: STORE_INCOMING_ACCESS_REQUESTS,
  pending,
  decided,
});

export const storeOutgoingAccessRequests = (pending, decided) => ({
  type: STORE_OUTGOING_ACCESS_REQUESTS,
  pending,
  decided,
});

/**
 * Outstanding asks for a specific set of employees — the employee wizard
 * needs these to show a "Requested" chip instead of an empty row, since a
 * queued grant is deliberately absent from the user record.
 */
export const fetchPendingAccessForUsers = (userIds) => ({
  type: FETCH_PENDING_ACCESS_FOR_USERS,
  userIds,
});

export const storePendingAccessForUsers = (requests) => ({
  type: STORE_PENDING_ACCESS_FOR_USERS,
  requests,
});

/**
 * One action for approve / reject / cancel / revoke — they differ only by
 * endpoint and all end the same way: refresh both queues.
 *
 * @param decision 'approve' | 'reject' | 'cancel' | 'revoke'
 */
export const decideAccessRequest = (decision, data, callback) => ({
  type: DECIDE_ACCESS_REQUEST,
  decision,
  data,
  callback,
});
